import React, { useEffect, useRef, useState } from "react";
import {
  Moon,
  Sun,
  Menu,
  X,
  Facebook,
  Linkedin,
} from "lucide-react";
import madisonLogo from "../assets/images/madisonLogo-1.webp";

export default function Navigation({
  theme,
  toggleTheme,
  currentPage,
  navigateTo,
  mobileMenuOpen,
  setMobileMenuOpen,
  showTopBar,
  setShowTopBar,
}) {
  const [headerVisible, setHeaderVisible] = useState(true);
  const lastScrollY = useRef(
    typeof window !== "undefined" ? window.scrollY : 0
  );
  const ticking = useRef(false);

  useEffect(() => {
    document.body.classList.toggle("no-top-bar", !showTopBar);
  }, [showTopBar]);

  useEffect(() => {
    const handleScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      window.requestAnimationFrame(() => {
        const currentY = window.scrollY || 0;
        const delta = currentY - lastScrollY.current;
        const threshold = 8;

        if (currentY < 60) {
          setHeaderVisible(true);
        } else if (delta > threshold) {
          setHeaderVisible(false);
        } else if (delta < -threshold) {
          setHeaderVisible(true);
        }

        lastScrollY.current = currentY;
        ticking.current = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={headerVisible ? "" : "header-hidden"}>
      {/* Top Bar */}
      {showTopBar && (
        <div className="top-bar">
          <div className="top-bar-content">
            <div className="connect-text">CONNECT WITH MADISON</div>
            <div className="social-icons">
              <a 
                href="https://www.facebook.com/p/Madison-Holdings-100046424636364/" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
              <a 
                href="https://www.linkedin.com/company/madison-holdings-limited/" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
            </div>
            <button className="close-btn" onClick={() => setShowTopBar(false)}>
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Main Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <button className="menu-icon" onClick={() => setMobileMenuOpen(true)}>
            <Menu size={22} />
          </button>
          <div className="logo" onClick={() => navigateTo("home")}>
            <img src={madisonLogo} alt="Madison" className="logo-img" />
            <span className="logo-sub">Madison Group</span>
          </div>
          <div className="nav-links">
            <a
              onClick={() => navigateTo("home")}
              className={currentPage === "home" ? "active" : ""}
            >
              Home
            </a>
            <a
              onClick={() => navigateTo("about")}
              className={currentPage === "about" ? "active" : ""}
            >
              About
            </a>
            <a
              onClick={() => navigateTo("subsidiaries")}
              className={currentPage === "subsidiaries" ? "active" : ""}
            >
              Subsidiaries
            </a>
            <a
              onClick={() => navigateTo("services")}
              className={currentPage === "services" ? "active" : ""}
            >
              Services
            </a>
            <a
              onClick={() => navigateTo("contact")}
              className={currentPage === "contact" ? "active" : ""}
            >
              Contact
            </a>
          </div>
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === "dark" ? <Moon size={16} /> : <Sun size={16} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
        <button
          className="mobile-menu-close"
          onClick={() => setMobileMenuOpen(false)}
        >
          <X size={28} />
        </button>
        <div className="mobile-nav-links">
          <a onClick={() => navigateTo("home")}>Home</a>
          <a onClick={() => navigateTo("about")}>About</a>
          <a onClick={() => navigateTo("subsidiaries")}>Subsidiaries</a>
          <a onClick={() => navigateTo("services")}>Services</a>
          <a onClick={() => navigateTo("contact")}>Contact</a>
        </div>
      </div>
    </div>
  );
}
